import styled from 'styled-components';

interface StyledErrorMessageProps {
  width?: string;
}

export const StyledErrorMessage = styled.p<StyledErrorMessageProps>`
  width: ${({ width }) => width || ''};
  margin: 5px 16px 0;
  color: #d20003;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;
